import { Injectable } from '@angular/core';
import { DataSyncSearchModel } from '../securehome/data-sync-search/data-sync-search.component';
import { ProductSearchModel } from '../securehome/picture-search/picture-search.component';

@Injectable({
  providedIn: 'root',
})
export class SharedSearchService {
  productSearchParams: ProductSearchModel = {};
  private dataSyncSearchParams: DataSyncSearchModel = {};

  constructor() {}

  getProductSearchParams() {
    return this.productSearchParams;
  }

  setProductSearchParams(params: ProductSearchModel) {
    this.productSearchParams = params;
  }

  getProductSearchParamsPage() {
    return this.productSearchParams.page;
  }

  setProductSearchParamsPage(searchPage: number) {
    this.productSearchParams.page = searchPage;
  }

  getProductSearchParamsPageSize() {
    return this.productSearchParams.pageSize;
  }

  setProductSearchParamsPageSize(searchPageSize: number) {
    this.productSearchParams.pageSize = searchPageSize;
  }

  getDataSyncSearchParams() {
    return this.dataSyncSearchParams;
  }

  setDataSyncSearchParams(params: DataSyncSearchModel) {
    this.dataSyncSearchParams = params;
  }

  getDataSyncSearchParamsPage() {
    return this.dataSyncSearchParams.page;
  }

  setDataSyncSearchParamsPage(searchPage: number) {
    this.dataSyncSearchParams.page = searchPage;
  }

  getDataSyncSearchParamsPageSize() {
    return this.dataSyncSearchParams.pageSize;
  }

  setDataSyncSearchParamsPageSize(searchPageSize: number) {
    this.dataSyncSearchParams.pageSize = searchPageSize;
  }
}
